import { config } from "config";
import { reviewState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const default_page_size = config.PAGE_SIZE;

const initialState: reviewState = {
  tab: 0,
  refresh: 0,
  refreshLoader: false,
  reviews: [],
  recentReviews: [],
  rejectedReviews: [],
  review: null,
  loading: true,
  count: 0,
  reviewOptions: [],
  current_filters: {},
  filters: { page: 1, pageSize: default_page_size },
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    clear: (state) => {
      state.reviewOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
      state.refreshLoader = true;
    },
    addReview: (state, action) => {
      state.reviews.unshift(action.payload);
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },

    updateReviewStatus: (state, action: PayloadAction<any>) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    setReview: (state, action) => {
      state.review = action.payload;
    },
    setReviews: (state, action) => {
      const { count, reviews } = action.payload;
      state.reviews = reviews;
      state.count = count;
      state.refreshLoader = false;
    },

    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },

    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
  },
});

const reviewReducer = reviewSlice.reducer;

export const reviewActions = reviewSlice.actions;
export default reviewReducer;
